import { HomeContentView } from "./HomeContentView"

/** A tela principal do site */
const HomeView = () => {
	return (
		<>
			<HomeContentView />
		</>
	)
}

export default HomeView
